import {
  APMT_IMG,
  OCEAN_IMG,
  LNS_IMG,
  GEOGRAPHY_IMG,
  TECHPLAT_IMG,
  FLEET_IMG,
  FINANCE_IMG,
  BRAND_IMG,
  HR_IMG,
  COSTCENTRE_IMG,
  PERFORMANCE_IMG,
  ENTITY_IMG,
  COMPANY_IMG,
  APPLICATION_IMG,
  TIME_IMG,
  VESSEL_IMG,
  FULFILLED_BY_IMG,
  TRANSPORTED_BY_IMG,
  BUSINESS_ENABLING_IMG,
  CORPORATE_PLATFORM_IMG,
  PLATFORM_ENABLER_IMG,
  MANAGED_BY_IMG,
  THEMIS_IMG,
  OTHERS_IMG,
  MASTER_DATA_IMG,
  SALES_IMG,
  DND_IMG,
  CONTRACTS_IMG,
  BOOKING_IMG,
  HSUD_IMG,
  SERVICE_DELIVERY_IMG,
  CERTIFIED_IMG
} from "../../constants/Constant";
export default class ImageUtils {
  getImage(value) {
    switch (value) {
      case "APMT":
        return APMT_IMG;
      case "LnS":
        return LNS_IMG;
      case "Ocean":
        return OCEAN_IMG;
      case "global":
        return GEOGRAPHY_IMG;
      case "TechPlatform":
        return TECHPLAT_IMG;
      case "Themis":
        return THEMIS_IMG;

      case "Applications":
        return APPLICATION_IMG;
      case "Booking":
        return BOOKING_IMG;
      case "Brand":
        return BRAND_IMG;
      case "Company":
        return COMPANY_IMG;
      case "Contracts":
        return CONTRACTS_IMG;
      case "CostCentre":
        return COSTCENTRE_IMG;
      case "Currency":
        return COSTCENTRE_IMG;
      case "DnD":
        return DND_IMG;
      case "Employee":
        return HR_IMG;
      case "Entity":
        return ENTITY_IMG;
      case "Finance":
        return FINANCE_IMG;
      case "Fleet":
        return FLEET_IMG;
      case "Geography":
        return GEOGRAPHY_IMG;
      case "HR":
        return HR_IMG;
      case "HSUD":
        return HSUD_IMG;
      case "Job":
        return HR_IMG;
      case "Others":
        return OTHERS_IMG;
      case "Payroll":
        return COSTCENTRE_IMG;
      case "Performance":
        return PERFORMANCE_IMG;
      case "Person":
        return HR_IMG;
      case "Recruitment":
        return HR_IMG;
      case "Sales":
        return SALES_IMG;
      case "Time":
        return TIME_IMG;
      case "System User":
        return HR_IMG;
      case "ServiceDelivery":
        return SERVICE_DELIVERY_IMG;
      case "masterdata":
        return MASTER_DATA_IMG;
      case "Vessel":
        return VESSEL_IMG;
      case "Vessel, ServiceDelivery":
        return VESSEL_IMG;

      case "Business Enabling":
        return BUSINESS_ENABLING_IMG;
      case "Corporate Platforms":
        return CORPORATE_PLATFORM_IMG;
      case "Fulfilled By":
        return FULFILLED_BY_IMG;
      case "Platform Enabler":
        return PLATFORM_ENABLER_IMG;
      case "Transported By":
        return TRANSPORTED_BY_IMG;
      case "Managed By":
        return MANAGED_BY_IMG;
      case "certified":
        return CERTIFIED_IMG;

      default:
        return OTHERS_IMG;
    }
  }
}
